export class TableConfig {
  /**
   * 组件对象，用于区分组件类型
   */
  [key: string]: any;
  ui?: {
    type: 'table'
  };
  /**
   * 表格名称
   */
  title?: any;

  /***
   * 表格数据请求参数
   */
  tableParams?: { [key: string]: any };
  /**
   * 表格数据
   */
  tableData?: any[];
  /**
   * 表头数据
   */
  titleObj?: object;
  /**
   * 是否有操作列
   */
  isOperation?: boolean;
  /**
   * 操作列配置
   */
  operationObj?: {
    name?: string, header?: string,
    attrs?: { width?: string, isOperation?: boolean, isTemplete?: boolean, isRight?: boolean }
  };
  /**
   * 操作列宽度
   */
  operationWidth?: string;
  /**
   * 是否分页
   */
  isPage?: boolean;
  /**
   * 每页显示条数
   */
  pageSize?: number;
  /**
   * 当前页码
   */
  page?: number;
  /**
   * 数据总条数
   */
  total?: number;
  /**
   * 表头信息 header(表头文字), name(表头对应的字段), width(表头宽度), isOperation(是否是操作列),
   *  isTemplete(是否自定义列), align(文字对齐方式), isSort(是否排序), type(字段类型)
   */
  columns?: [
    {
      header?: string;
      name?: string;
      width?: any;
      isOperation?: boolean;
      isTemplete?: boolean;
      align?: string;
      isSort?: boolean;
      type?: string;  // 当前列对应的数据类型
      others?: object;  // 对应组件配置，比如下拉，日期或输入框，设置组件类型，接口地址，请求参数，默认数据等
      left?: boolean; // 固定在左边
      right?: boolean; // 固定在右边
      attrs?: object;  // 列的扩展属性(width, type)
      searchItem?: object; // 搜索项
      // isColSearch: object;  // 列搜索配置
    }
  ];
  /**
   *  是否默认加载表格
   */
  defaultLoad?: boolean;
  /**
   * 是否显示行号
   */
  showRowNum?: boolean;
  /**
   * 是否设置单选
   */
  radioChec?: boolean;
  /**
   * 是否设置多选
   */
  comCheck?: boolean;
  /**
   * table容器的宽度
   */
  width?: number;
  /**
   * 是否显示高级搜索
   */
  isHeader?: boolean;
  /**
   * 是否可修改列
   */
  isUpdateCols?: boolean;
  /**
   * 是否在下拉里显示不固定列
   */
  /***
   * 表头接口地址
   */
  // queryTitle?: string;
  // /**
  //  * 表格数据接口地址
  //  */
  // queryTable?: string;
  // /**
  //  * 表头请求参数, mapperCode,用于后端识别对应mapper
  //  */
  // titleParams?: {mapperCode?: string};
  // isCollapse?: boolean;
  // /**
  //  * 是否编辑
  //  */
  // isEdit?: boolean;
  // /**
  //  * 是否单个删除
  //  */
  // isDelete?: boolean;
  // /**
  //  * 是否批量删除
  //  */
  // isBatchDelete?: boolean;
  // /**
  //  * 是否显示添加按钮
  //  */
  // isAdd?: boolean;
  // /**
  //  * 是否显示导出按钮
  //  */
  // isExport?: boolean;
  // /**
  //  * 是否显示导入按钮
  //  */
  // isImport?: boolean;
  // /**
  //  * 单选删除配置
  //  */
  // deleteConfig?: {
  //   key?: string,
  //   url?: string,
  //    clickEvent?: (...deleteConfig) => any;
  //   };
  // /**
  //  * 编辑按钮配置
  //  */
  // editConfig?: {
  //   clickEvent?: any;
  //   mapperUrl?: string,
  //   mapperParams?: any,
  // };
  // /**
  //  * 添加按钮配置
  //  */
  // // clickEvent?: (...addConfig) => {}
  // addConfig?: {
  //   params?: {},
  //   url?: string,
  //   mapperUrl?: string,
  //   mapperParams?: any,
  //   clickEvent?: (...addConfig) => any
  // };
  // /**
  //  * 批量删除配置
  //  */
  // batchDeleteConfig?: {
  //   key?: string,
  //   url?: string
  //    clickEvent?: (...batchDeleteConfig) => any;
  //   };
  // /**
  //  * 导出配置
  //  */
  // exportConfig?: {
  // };
  // /**
  //  * 导入配置
  //  */
  // importConfig?: {
  //   params?: {},
  //   url?: {},
  //   clickEvent?: (...importConfig) => any
  // };
  /**
   * 列搜索配置
   */
  // colSearchItems?: any[];
  /**
   * 列搜索初始配置
   */
  colSearchConfig?: any[];
  /** --------------树表---------------- */
  /** */
  key?: string;
  /**
   * 子节点数组
   */
  children?: [];
  /**
   * 是否是叶子节点
   */
  isLeaf?: boolean;
  /**
   * 子节点缩进
   */
  level?: number;
  /**
   * 是否全部展开
   */
  isExpandAll?: boolean;
  /**
   * 是否展开某一项
   */
  expanded?: boolean;
  /**
   * 当前行是否是选中状态
   */
  active?: boolean;
  /**
   * 当前行是否是选中状态
   */
  checked?: boolean;

  /**
   * 表格滚动高度
   */
  scrollY?: number;

  /** ------------------可编辑单元格------------------ */
  /**
   * 是否可编辑单元格
   */
  isEditCol?: boolean;
  /**
   * 是否显示添加行按钮
   */
  showAdd?: boolean;
  /**
   * 是否重载表格
   */
  reLoad?: boolean;
  /**
   * 是否显示删除按钮（只针对可编辑单元格表格）
   */
  showDelete?: boolean;

  /**
   * 是否显示表格边框
   */
  isBorder?: boolean;
  /**
   * 是否显示分页器
   */
  isShowPagination?: boolean;

  constructor(
  ) {
    this.title = this.title;
    this.defaultLoad = true;
    this.showRowNum = true;
    this.isOperation = true;
    this.isPage = true;
    this.isBorder = false;
    this.page = 1;
    this.pageSize = 10;
    this.total = 0;
    this.checked = false;
    this.active = false;
    this.radioChec = true;
    this.comCheck = true;
    this.isExpandAll = false;
    this.isLeaf = false;
    this.colSearchConfig = [];
    this.tableParams = {};
    this.reLoad = false;
    this.isShowPagination = true;
  }
}
